import { Component, inject, OnInit } from '@angular/core';
import { SpinnerComponent } from '@/components/shared/spinner/spinner.component';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { getFormBuilderObjectFactory } from '@/components/form-builder/utils/form-builder-factory';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { DynamicFormsService } from '../dynamic-forms.service';
import { MessageService } from 'primeng/api';
import { DynamicFormTransformationService } from '../dynamic-form-transformation.service';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { FormType } from '@/types';
import { CommonModule } from '@angular/common';
import { getDatatableBuilderObjectFactory } from '@/components/data-table-builder/utils/datatable-builder-factory';
import { getInspectDynamicFormFormObject } from './utils/dynamic-form.form-object';
import { DynamicFormRepository } from '@/store/dynamic-form-state/dynamic-form.repository';

@Component({
  selector: 'sm-inspect-dynamic-form',
  imports: [SpinnerComponent, PageHeaderComponent, FormBuilderComponent, DataTableBuilderComponent, CommonModule],
  templateUrl: './inspect-dynamic-form.component.html',
  styleUrl: './inspect-dynamic-form.component.scss',
})
export class InspectDynamicFormComponent implements OnInit {
  dynamicFormRepository = inject(DynamicFormRepository);
  dynamicFormService = inject(DynamicFormsService);
  translate = inject(TranslateService);
  messageService = inject(MessageService);
  activatedRoute = inject(ActivatedRoute);
  dynamicFormTransformationService = inject(DynamicFormTransformationService);

  id = this.activatedRoute.snapshot.params['id'] as number;
  breadcrumb = [
    {
      label: 'transanctionalForm.title',
      routerLink: ['/settings', 'dynamic-forms'],
    },
    {
      label: 'transanctionalForm.pages.inspect',
      routerLink: ['/settings', 'dynamic-forms-inspect', this.id.toString()],
    },
  ];

  loading$ = new BehaviorSubject<boolean>(false);
  title: string = this.translate.instant('transanctionalForm.pages.inspect');

  type?: FormType;
  globalFormObject: DynamicForm = getInspectDynamicFormFormObject({
    store: this.dynamicFormRepository,
  });
  formObject: DynamicForm = getFormBuilderObjectFactory();
  datatableObject: DynamicDataTable = getDatatableBuilderObjectFactory();

  ngOnInit() {
    this.dynamicFormService.getDynamicForm(this.id).subscribe({
      next: data => {
        this.dynamicFormRepository.setDynamicFormDto(data);
        this.type = data.formType;
        if (this.type === 'TABLE') {
          this.datatableObject = this.dynamicFormTransformationService.getTableObject(data);
        } else if (this.type === 'FORM') {
          this.formObject = this.dynamicFormTransformationService.getFormObject(data);
        }
        this.loading$.next(false);
      },
      error: err => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: err.message || 'Une erreur est survenue lors de la récupération du formulaire dynamique',
        });
        this.loading$.next(false);
      },
    });
  }
}
